export default "__VITE_ASSET__X0VjLp5eIbDPt9fHLW8ANA__"